import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { CompanyCashFlow } from "../../companyd";
import { getCashFlowStatement } from "../../api";
import Table from "../Table/Table";
import Spinner from "../Spinner/Spinner";
import { formatLargeMonetaryNumber } from "../../Helper/NumberFormatting";
//import Spinner from "../Spinners/Spinner";

type Props = {};


const config = [
    {
        label: "Date",
        render: (company: CompanyCashFlow) => company.date,
        subTitle: "Reporting period for the cash flow statement",
    },
    {
        label: "Operating Cash Flow",
        render: (company: CompanyCashFlow) =>
            formatLargeMonetaryNumber(company.operatingCashFlow),
        subTitle:
            "Cash generated from core business operations",
    },
    {
        label: "Investing Cash Flow",
        render: (company: CompanyCashFlow) =>
            formatLargeMonetaryNumber(
                company.netCashUsedForInvestingActivites
            ),
        subTitle:
            "Cash used for investments like assets or acquisitions",
    },
    {
        label: "Financing Cash Flow",
        render: (company: CompanyCashFlow) =>
            formatLargeMonetaryNumber(
                company.netCashUsedProvidedByFinancingActivities
            ),
        subTitle:
            "Cash from or paid to investors and creditors",
    },
    {
        label: "Cash At End of Period",
        render: (company: CompanyCashFlow) =>
            formatLargeMonetaryNumber(company.cashAtEndOfPeriod),
        subTitle:
            "Total cash remaining at the end of the reporting period",
    },
    {
        label: "Capital Expenditure (CapEx)",
        render: (company: CompanyCashFlow) =>
            formatLargeMonetaryNumber(company.capitalExpenditure),
        subTitle:
            "Money spent on acquiring or maintaining physical assets",
    },
    {
        label: "Issuance Of Stock",
        render: (company: CompanyCashFlow) =>
            formatLargeMonetaryNumber(company.commonStockIssued),
        subTitle:
            "Cash raised by issuing new shares",
    },
    {
        label: "Free Cash Flow",
        render: (company: CompanyCashFlow) =>
            formatLargeMonetaryNumber(company.freeCashFlow),
        subTitle:
            "Cash available after capital expenditures (key profitability metric)",
    },
];

const CashFlowStatement = (props: Props) => {
    const ticker = useOutletContext<string>();
    const [cashFlowData, setCashFlowData] = useState<CompanyCashFlow[]>();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchCashFlow = async () => {
            const result = await getCashFlowStatement(ticker);
            if (typeof result === "string") {
                setError(result);
            } else if (Array.isArray(result) && result.length > 0 && result[0] && Object.keys(result[0]).length > 0) {
                setCashFlowData(result);
                setError(null);
            } else {
                setError("No data available.");
            }
        };
        fetchCashFlow();
    }, [ticker]);

    return (
        <div className="w-full px-4 sm:px-0">
            {error ? (
                <div className="w-full text-center mt-10 text-white"><h2>{error}</h2></div>
            ) : cashFlowData && cashFlowData.length > 0 ? (
                <Table config={config} data={cashFlowData}></Table>
            ) : (
                <Spinner />
            )}
        </div>
    );
};

export default CashFlowStatement;